import { Checkbox } from '@velocity/ui';
import React from 'react';

export interface FormCheckboxFieldProps {
  name: string;
  label: React.ReactNode;
  checked?: boolean | null;
  onChange: (checked: boolean) => void;
  onBlur?: () => void;
  disabled?: boolean;
  className?: string;
  dataTestId?: string;
}

/*
 * Velocity `Checkbox` (Figma: formkit/checkbox-with-label, small 16px).
 * Controlled, meant to be used with react-hook-form's `Controller`.
 */
const FormCheckboxField: React.FC<FormCheckboxFieldProps> = ({
  name,
  label,
  checked,
  onChange,
  onBlur,
  disabled,
  className,
  dataTestId,
}) => (
  <Checkbox
    name={name}
    label={label}
    checked={!!checked}
    disabled={disabled}
    className={className}
    onChange={(event) => onChange(event.target.checked)}
    onBlur={onBlur}
    data-testid={dataTestId ?? `checkbox-${name}`}
  />
);

export default FormCheckboxField;
